import { Carousel } from "react-responsive-carousel";
import { SideBySideMagnifier } from "react-image-magnifiers";
import { GlassMagnifier } from "react-image-magnifiers";

import "react-responsive-carousel/lib/styles/carousel.min.css";

//import "./styles.css";
export default function ZoomImage() {
    const renderCustomThumbs = () => {
        return [
            <picture>
                <source
                    data-srcSet="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                    type="image/jpg"
                />
                <img
                    key="01"
                    src="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                    alt="First Thumbnail"
                    height="70"
                />
            </picture>,
            <picture>
                <source
                    data-srcSet="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                    type="image/jpg"
                />
                <img
                    key="02"
                    src="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                    alt="Second Thumbnail"
                    height="70"
                />
            </picture>
        ];
    };

    return (
        <>
            <h2>With Carousel magnifiers dosen't works </h2>
            <div style={{ width: "50%" }}>
                <Carousel
                    showArrows={false}
                    showStatus={true}
                    showIndicators={true}
                    showThumbs={true}
                    autoPlay={false}
                    transitionTime={500}
                    swipeable={false}
                    emulateTouch={true}
                    renderThumbs={renderCustomThumbs}
                >
                    <div>
                        <GlassMagnifier
                            imageSrc="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                            imageAlt="First Slide"
                            alwaysInPlace={false}
                            fillAvailableSpace={true}
                            fillAlignTop={true}
                            fillGapRight={10}
                            fillGapBottom={10}
                            fillGapTop={10}
                            fillGapLeft={0}
                        />
                    </div>
                    <div>
                        <GlassMagnifier
                            imageSrc="https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"
                            imageAlt="Second Slide"
                            alwaysInPlace={false}
                            fillAvailableSpace={true}
                            fillAlignTop={true}
                            fillGapRight={10}
                            fillGapBottom={10}
                            fillGapTop={10}
                            fillGapLeft={0}
                        />
                    </div>
                </Carousel>
            </div>
            <h2>Without Carousel magnifiers works </h2>

            <div style={{ width: "50%" }}>
                <GlassMagnifier
                    imageSrc={"https://i.ibb.co/z5CC6P9/AB-10000008011.jpg"}
                    alwaysInPlace={false}
                    fillAvailableSpace={true}
                    fillAlignTop={true}
                    fillGapRight={10}
                    fillGapBottom={10}
                    fillGapTop={10}
                    fillGapLeft={0}
                />
            </div>
        </>
    );
}
